import { apiAxios } from "./axios";
import { FeatureFlag } from "../common/models/Models";

class FeatureFlagsService {
  async listFlags(): Promise<FeatureFlag[]> {
    const response = await apiAxios.get<FeatureFlag[]>("/feature-flags");
    return response.data;
  }

  async getFlag(name: string): Promise<FeatureFlag> {
    const response = await apiAxios.get<FeatureFlag>(`/feature-flags/${name}`);
    return response.data;
  }

  async setFlag(name: string, enabled: boolean): Promise<FeatureFlag> {
    const response = await apiAxios.put<FeatureFlag>(`/feature-flags/${name}`, {
      enabled,
    });
    return response.data;
  }
}

const featureFlagsService = new FeatureFlagsService();
export default featureFlagsService;
